import app from '@/app';
import templateUrl from './project-detail.html';

/* @ngInject */
function Controller($controller, ProjectEntity, Principal) {
	var $ctrl = this;

	$ctrl.currentAccount = null;
	$ctrl.selectableUsers = [];

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
		applyUserFilter();
	});

	$ctrl.$onInit = applyUserFilter;

	// Hides the current user, system users and administrators: both already have
	// access to every record, so they are never authorized individually
	function applyUserFilter() {
		if (!$ctrl.currentAccount || !$ctrl.allUsers || !$ctrl.allUsers.content) {
			return;
		}
		$ctrl.selectableUsers = $ctrl.allUsers.content.filter(user => {
			if (user.login === $ctrl.currentAccount.login) return false;
			if (isSystem(user)) return false;
			return !isAdmin(user);
		});
	}

	function isSystem(user) {
		return (user.authorities || []).indexOf('SYSTEM') !== -1;
	}

	function isAdmin(user) {
		return (user.authorities || []).indexOf('USERS_WRITE') !== -1;
	}

	$controller('AbstractEntityDetailController', {
		$ctrl,
		resource: ProjectEntity,
		type: 'project'
	});

	// Define the preventEnterSubmit function
	$ctrl.preventEnterSubmit = function(event) {
		if (event.keyCode === 13) {
			// Check if the key pressed is the Enter key (keyCode 13)
			event.preventDefault(); // Prevents the form submission
		}
	};

	// Checks if the user is in the list of authorized users
	$ctrl.isAuthorized = function(user) {
		return (
			$ctrl.entity.authorizedUsers &&
			$ctrl.entity.authorizedUsers.some(function(u) {
				return u.id === user.id;
			})
		);
	};

	// Adds or removes the user from the list of authorized users
	$ctrl.toggleUser = function(user) {
		if (this.projectForm) {
			this.projectForm.$setDirty();
		}
		if (!$ctrl.entity.authorizedUsers) {
			$ctrl.entity.authorizedUsers = [];
		}

		const index = $ctrl.entity.authorizedUsers.findIndex(function(u) {
			return u.id === user.id;
		});

		if (index > -1) {
			// User is already in the list → remove it
			$ctrl.entity.authorizedUsers.splice(index, 1);
			return;
		}
		// User is not in the list → add it
		$ctrl.entity.authorizedUsers.push(user);
	};
}

const component = {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^projectSearch'
	},
	bindings: {
		$transition$: '<',
		entity: '<',
		allUsers: '<'
	}
};

app.component('projectDetail', component);
